import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReferralType, BiEventType } from '@wix/da-bi/pkg/constants';
import PremiumIcon from '@wix/da-ds/pkg/Icons/Premium';
import PcpPopover from '../../../../PcpPopover';
import ActionBarIcon from '../../../_partials/ActionBarIcon';
import ActionBarButtonRestriced from '../../../_partials/ActionBarButtonRestriced';
// TODO: very similar to DownloadButtonWithPopover, consolidate
var PcpButtonWithPopover = function (_a) {
    var deviation = _a.deviation, onDownload = _a.onDownload, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, iconRef = _a.iconRef;
    var t = useTranslation().t;
    return (React.createElement(ActionBarButtonRestriced, { restrictedActionName: ReferralType.ANON_DOWNLOAD, tooltip: t('actionbar.pcp'), renderPopover: function (_a) {
            var closeTooltip = _a.closeTooltip;
            return (React.createElement(PcpPopover, { deviation: deviation, closeTooltip: closeTooltip, onDownload: onDownload }));
        }, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, biData: {
            evid: BiEventType.CLICK_DOWNLOAD_BUTTON,
            deviationid: deviation.deviationId,
            ispaiddownload: 1,
        } },
        React.createElement(ActionBarIcon, { icon: PremiumIcon, iconRef: iconRef })));
};
PcpButtonWithPopover.displayName = 'PcpButtonWithPopover';
export default PcpButtonWithPopover;
//# sourceMappingURL=PcpButtonWithPopover.js.map